<template>
	<v-dialog v-model="dialog" max-width="500px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="#1A237E" class="text-lowercase" icon v-on="on">
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-icon small v-on="on">mdi-lead-pencil</v-icon>
					</template>
					<span>edit brands</span>
				</v-tooltip>
			</v-btn>
		</template>
		<v-card v-if="!loading">
			<v-card-title class="pt-6 subtitle-2">
				Edit trademarks in chain 
					<span class="accentColor"> {{ chain.name }}</span>
			</v-card-title>
			<v-card-text class="black--text">
				<v-container grid-list-md>
				<v-form v-model="valid" ref="form" validation>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-select dense
								v-model="trademark"
								:items="trademarks"
								item-text="name"
								multiple
								attach
								chips
								color="#1A237E"
								item-color="#1A237E"
								label="trademarks"
								@change="onceMore()"
								:rules="requiredRules">
							</v-select>
						</v-col>
					</v-row>
				</v-form>
				</v-container>
				<v-row justify="center" class="error mx-2">{{ error }}</v-row>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="#1A237E" text
					class="text-capitalize" 
					@click="closeDialog">
					Decline
				</v-btn>
				<v-btn color="#1A237E" text
					class="text-capitalize"
					:disabled="loading || Boolean(error)"
					@click="changeChannel"
					>Change</v-btn>
			</v-card-actions>
		</v-card>
		<div v-else class="text-center">
			<loader></loader>
		</div>
	</v-dialog>
</template>

<script>
	import Loader from '../../layouts/Loader.vue'

	export default {
		props: ['chain', 'channel', 'gameId', 'round'],
		data () {
			return	{
				dialog: false,
				valid: false,
				name: this.chain.name,
				trademark: this.channel.trademarks,
				error: '',
				requiredRules: [v => !!v || 'this field is required'],
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			}, 
			inIndependentChains () {
				return this.$store.getters.inIndependentChains
			},
			trademarks () {
				return this.$store.getters.trademarks
			}
		},
		methods: {
			onceMore() {
				this.error =''	
			},
			async changeChannel () {
				const ch = this.inIndependentChains.find(channel => channel.chainId == this.chain.id)

				if (ch) {
					if (this.trademark.length < 1) {
						this.error = 'This chain should sell at least one trademark'
					}
					else if (ch.trademarks === this.trademark) {
						this.error = 'You didn\'t any trademark\'s change'
					}
					else {
						ch.trademarks = this.trademark
						try {
							//
							await this.$store.dispatch('changeChannel', {
								gameId: this.gameId,
								round: this.round,
								channel: ch
							})
							this.closeDialog ()				
						}
						catch (error) {
							this.error= error.message
						}
					}
				}
			},
			closeDialog () {
				//reset
				this.dialog = false
				this.error = ''
			}
		},
		components: {Loader}
	}
</script>